// extracted by mini-css-extract-plugin
export default {"kpi-divider":"components-general-smart-insights-detail-view-smart-insight-kpi-blocks-module__kpi-divider"};